/* eslint sort-keys: ["error", "asc"] */
/**
 * @file Routes to various pages in the application are defined here rather than being
 * hard-coded into various files.
 */
/** Based on Mass PFML: https://github.com/navapbc/archive-massgov-pfml/blob/main/portal/src/routes.ts */

const routes = {
  external: {
    massgov: {
      accessibilityStatement:
        'https://www.mass.gov/info-details/commonwealth-of-massachusetts-executive-department-digital-accessibility-statement',
      ccrr_offices: 'https://eeclead.my.site.com/EEC_CCRRSearch',
      childCareAndFinancialAssistance: 'https://www.mass.gov/child-care-financial-assistance',
      childCareBenefitFees:
        'https://www.mass.gov/info-details/while-getting-child-care-financial-assistance#telling-family-access-administrators-about-changes',
      childCareFinancialAssistanceForms: 'https://www.mass.gov/lists/common-forms-for-child-care-financial-assistance',
      childCareFinancialAssistancePolicy:
        'https://www.mass.gov/collections/child-care-financial-assistance-policy-guidance-and-resources',
      documents: 'https://www.mass.gov/info-details/child-care-financial-assistance-what-information-you-need-to-give',
      domesticViolenceServices: 'https://www.mass.gov/domestic-violence-services',
      educationAndCareProviders: 'https://www.mass.gov/topics/early-education-care-providers',
      eec: 'https://www.mass.gov/orgs/department-of-early-education-and-care',
      eecCommonForms: 'https://www.mass.gov/lists/common-forms-for-child-care-financial-assistance',
      eecPolicyGuidance:
        'https://www.mass.gov/collections/child-care-financial-assistance-policy-guidance-and-resources',
      feedbackEmbedded: 'https://forms.office.com/g/ZjB42vss5Y?embed=true',
      homeMyChildCareMA: 'https://childcare.mass.gov/families/',
      howToApplyForChildCare: 'https://www.mass.gov/how-to/apply-for-funds-to-help-pay-for-child-care',
      managingChildCareAndFinancialAssistance: 'https://www.mass.gov/guides/managing-child-care-financial-assistance',
      portal: 'https://www.mychildcarema.com/',
      privacyPolicy: 'https://www.mass.gov/privacypolicy',
      providers: 'https://www.mass.gov/guides/find-a-licensed-family-group-or-school-age-child-care-program',
      publicCharge:
        'https://www.mass.gov/info-details/information-about-the-public-charge-rule-and-how-it-may-impact-you',
      search: 'https://childcare.mass.gov/findchildcare',
      serviceNeed: 'https://www.mass.gov/',
    },
    phones: {
      domestic_violence_hotline: '(877) 785-2020',
      eec_fax_number: '(617) 988-2451',
      main_office_tty_number: '(800) 439-2370',
      mass_211_contact_number: '(877) 211-6277',
    },
  },
  internal: {
    consentAgreement: '/families/security-policy',
    documents: '/upload',
    faq: '/frequently-asked-questions',
    feedback: '/survey',
    home: '/home',
    qualifiedCitizen: '#citizenship-eligibility',
    securityPolicy: '/security-policy',
    timeline: '/frequently-asked-questions#benefit-eligibility',
  },
};

export default routes;
